import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { VitrineCoverBlockType } from "@biteinc/enums";
//#region src/utils/menu_cover_utils.ts
var menu_cover_utils_exports = /* @__PURE__ */ __exportAll({
	isLargeMediaBlockType: () => isLargeMediaBlockType,
	isPromoBlock: () => isPromoBlock
});
function isPromoBlock(block) {
	switch (block.type) {
		case VitrineCoverBlockType.PromoSmall:
		case VitrineCoverBlockType.PromoMedium:
		case VitrineCoverBlockType.PromoRegular: return true;
		case VitrineCoverBlockType.CoverImageExtraSmall:
		case VitrineCoverBlockType.CoverImageLarge:
		case VitrineCoverBlockType.CoverImageMedium:
		case VitrineCoverBlockType.CoverImageSmall:
		case VitrineCoverBlockType.CoverVideoExtraSmall:
		case VitrineCoverBlockType.CoverVideoLarge:
		case VitrineCoverBlockType.CoverVideoMedium:
		case VitrineCoverBlockType.CoverVideoSmall:
		case VitrineCoverBlockType.BottomSection:
		case VitrineCoverBlockType.Pathway: return false;
	}
}
function isLargeMediaBlockType(blockType) {
	switch (blockType) {
		case VitrineCoverBlockType.CoverImageLarge:
		case VitrineCoverBlockType.CoverVideoLarge: return true;
		case VitrineCoverBlockType.CoverImageExtraSmall:
		case VitrineCoverBlockType.CoverImageMedium:
		case VitrineCoverBlockType.CoverImageSmall:
		case VitrineCoverBlockType.CoverVideoExtraSmall:
		case VitrineCoverBlockType.CoverVideoMedium:
		case VitrineCoverBlockType.CoverVideoSmall:
		case VitrineCoverBlockType.PromoMedium:
		case VitrineCoverBlockType.PromoRegular:
		case VitrineCoverBlockType.PromoSmall:
		case VitrineCoverBlockType.BottomSection:
		case VitrineCoverBlockType.Pathway: return false;
	}
}
//#endregion
export { isLargeMediaBlockType, isPromoBlock, menu_cover_utils_exports };

//# sourceMappingURL=menu_cover_utils.js.map